(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["talon-bundle-checkout"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('talon-bundle-checkout')) {
  class TalonBundleCheckout extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.radios = [...this.querySelectorAll('.tb__radio')];
      const params = new URLSearchParams(location.search);
      const count = params.get('bottles');
      const requested = this.radios.find(radio => radio.value === count && !radio.disabled);
      if (requested) requested.checked = true;
      let initial = this.radios.find(radio => radio.checked && !radio.disabled);
      if (!initial) initial = this.radios.find(radio => !radio.disabled);
      if (initial) { initial.checked = true; this.select(initial, false); }
      else this.querySelectorAll('[data-checkout-link]').forEach(button => { button.disabled = true; });
      this.addEventListener('change', event => {
        if (event.target.matches('.tb__radio')) this.select(event.target, true);
        if (event.target.matches('[data-bundle-quantity]')) {
          const selected = this.radios.find(radio => radio.checked && !radio.disabled);
          if (selected) this.select(selected, false);
        }
      });
      this.querySelector('#TalonCheckoutForm-' + this.id.replace('TalonBundles-', '')).addEventListener('submit', event => {
        if (this.dataset.checkoutBusy === 'true') {
          event.preventDefault();
          return;
        }
        this.dataset.checkoutBusy = 'true';
        this.querySelectorAll('[data-checkout-link]').forEach(button => {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        });
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('.tb__gallery-button');
        if (!button || !this.contains(button)) return;
        const image = this.querySelector('.tb__hero-image');
        image.removeAttribute('srcset');
        image.src = button.dataset.galleryImage;
        image.alt = button.dataset.galleryAlt;
        this.dataset.galleryDetail = String(!button.hasAttribute('data-gallery-package'));
        this.querySelectorAll('.tb__gallery-button').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      });
      const photo = this.querySelector('.tb__photo');
      photo.addEventListener('pointerdown', event => { this.galleryPointer = {x:event.clientX,y:event.clientY}; });
      photo.addEventListener('pointerup', event => {
        if (!this.galleryPointer) return;
        const dx = event.clientX - this.galleryPointer.x;
        const dy = event.clientY - this.galleryPointer.y;
        this.galleryPointer = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        const buttons = [...this.querySelectorAll('.tb__gallery-button')];
        const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        buttons[(Math.max(0,current) + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length].click();
      });
      this.querySelector('.tb__gallery').addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const buttons = [...this.querySelectorAll('.tb__gallery-button')];
        const current = buttons.indexOf(event.target);
        const next = buttons[(Math.max(0,current)+(event.key === 'ArrowRight' ? 1 : -1)+buttons.length)%buttons.length];
        next.click(); next.focus();
      });
      this.onPageShow = event => {
        if (event.persisted && this.dataset.checkoutBusy === 'true') window.location.reload();
      };
      window.addEventListener('pageshow', this.onPageShow);
      this.onScroll = () => {
        const primary = this.querySelector('.tb__purchase > [data-checkout-link]');
        const bounds = primary.getBoundingClientRect();
        this.dataset.sticky = String(bounds.bottom < 0 || (this.getBoundingClientRect().top < innerHeight && bounds.top > innerHeight));
      };
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll, {passive:true});
      this.onScroll();
    }
    select(radio, updateUrl) {
      if (radio.disabled) return;
      const data = radio.dataset;
      const quantity = Number(this.querySelector('[data-bundle-quantity]').value);
      const total = quantity === 1 ? data.total : new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency}).format(Number(data.price) * quantity / 100);
      const name = quantity === 1 ? data.name : `${quantity} × ${data.name}`;
      this.querySelector('[data-checkout-variant]').value = data.variant;
      this.querySelectorAll('.tb__gallery-button').forEach(button => button.setAttribute('aria-pressed','false'));
      const image = this.querySelector('.tb__hero-image');
      image.removeAttribute('srcset');
      image.src = data.image;
      image.alt = data.imageAlt;
      this.dataset.galleryDetail = 'false';
      const packageButton = this.querySelector('[data-gallery-package]');
      if (packageButton) {
        packageButton.dataset.galleryImage = data.image;
        packageButton.dataset.galleryAlt = data.imageAlt;
        packageButton.setAttribute('aria-pressed','true');
        packageButton.querySelector('img').src = data.image;
        packageButton.querySelector('img').removeAttribute('srcset');
      }
      this.querySelector('[data-visual-package]').textContent = `${data.name} · ${data.capsules} · ${data.supply}`;
      this.querySelector('[data-selected-name]').textContent = name;
      this.querySelector('[data-selected-details]').textContent = `${data.supply} · ${data.capsules}`;
      this.querySelector('[data-selected-total]').textContent = total;
      this.querySelector('[data-mobile-name]').textContent = name;
      this.querySelector('[data-mobile-price]').textContent = total;
      this.querySelector('[data-details-link]').href = data.url;
      this.querySelectorAll('[data-checkout-link]').forEach(link => {
        link.disabled = false;
        link.removeAttribute('aria-disabled');
        link.removeAttribute('tabindex');
      });
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('bottles',radio.value);
        history.replaceState(null,'',url);
      }
      this.dispatchEvent(new CustomEvent('talon:package-change', {bubbles:true,detail:{bottles:Number(radio.value),variantId:data.variant}}));
    }
    disconnectedCallback() {
      window.removeEventListener('pageshow', this.onPageShow);
      window.removeEventListener('scroll',this.onScroll);
      window.removeEventListener('resize',this.onScroll);
    }
  }
  customElements.define('talon-bundle-checkout',TalonBundleCheckout);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talon-formula"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const canvas=root.querySelector('canvas'),ctx=canvas.getContext('2d'),range=root.querySelector('input'),img=new Image();let ready=false,touched=false,scheduled=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;function draw(n){if(!ready)return;n=Math.max(0,Math.min(92,Math.round(n)));ctx.drawImage(img,(n%8)*360,Math.floor(n/8)*640,360,640,0,0,610,1080);range.value=n}img.onload=()=>{ready=true;draw(65)};const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){img.src='https://cdn.shopify.com/s/files/1/0671/2914/7592/files/talon-rotation-fixed.webp?v=1792188311';observer.disconnect()}},{rootMargin:'600px'});observer.observe(root);range.addEventListener('input',()=>{touched=true;draw(Number(range.value))});function scroll(){if(touched||reduced||scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;const r=root.querySelector('.tf-dark').getBoundingClientRect();const progress=Math.max(0,Math.min(1,(innerHeight*.8-r.top)/(innerHeight*.7)));draw(progress*92)})}addEventListener('scroll',scroll,{passive:true})}document.querySelectorAll('[data-talon-formula]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-talon-formula]').forEach(init))})();

  } catch(e) { console.error(e); }
})();
})();
